import React from "react";

import "./Footer.css";

function Footer() {
  return (
    <div className="footerParentDiv">
      {/* <div className="content">
        <div>
          <div className="heading">
            <p>POPULAR LOCATIONS</p>
          </div>
          <div className="list">
            <ul>
              <li>Kannur</li>
              <li>Ernakulam</li>
              <li>Kozhikode</li>
              <li>Banglore</li>
            </ul>
          </div>
        </div>
        <div>
          <div className="heading">
            <p>ABOUT US</p>
          </div>
          <div className="list">
            <ul>
              <li>About OLX Group</li>
              <li>Careers</li>
              <li>Contact Us</li>
              <li>OLXPeople</li>
            </ul>
          </div>
        </div>
        <div>
          <div className="heading">
            <p>OLX</p>
          </div>
          <div className="list">
            <ul>
              <li>Help</li>
              <li>Sitemap</li>
              <li>Legal & Privacy information</li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className="footer">
        {/* <p>Other Countries Pakistan - South Africa - Indonesia</p> */}
        {/* <p>Free Classifieds in India. © 2006-2021 OLX</p> */}
        <p>Free Classifieds in India. © 2021 copyright all right reserved</p>
      </div>
    </div>
  );
}

export default Footer;
